export const DISPONIBLE = 'Disponible';
export const NO_DISPONIBLE = 'No disponible';
